import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => (
  <></>
);

export default Footer;
